import { detailInfoStore } from "@/routes/org/_components/modal/detail-info-store"
import { langStore } from "@/stores/lang-store"
import GridCard from "./grid-card"

const GridCards = ({ rows = [] }) => {
  const { lang } = langStore()
  const openModal = detailInfoStore((s) => s.openModal)

  if (rows.length === 0) {
    return <div className="text-center py-6 text-gray-400">조건결과가 없습니다.</div>
  }

  return (
    <div className="mt-4 space-y-3">
      {rows.map((hit, idx) => (
        <GridCard key={idx} hit={hit} lang={lang} onOpen={() => openModal(hit)} />
      ))}
    </div>
  )
}

export default GridCards
